import { useState, useEffect } from "react";
import Guideline from "./components/Guideline";
import CheckQuality from "./components/CheckQuality";
import Verifying from "./components/Verifying";
// TODO: Replace with actual MyTentera guideline images
import mytenteraFrontGood from "../../assets/images/guideline-mytentera-front-good.jpg";
import mytenteraFrontBad from "../../assets/images/guideline-mytentera-front-bad.jpg";
import mytenteraBackGood from "../../assets/images/guideline-mytentera-back-good.jpg";
import mytenteraBackBad from "../../assets/images/guideline-mytentera-back-bad.jpg";
import TakePhotoError from "./components/TakePhotoError";
import { useLocation } from "react-router-dom";
import InvalidToken from "./components/InvalidToken";
import { useMyTenteraService } from "./useMyTenteraService";
import UploadPhoto from "./components/UploadPhoto";
import MyTenteraReject from "./components/MyTenteraReject";
import MultipleReject from "./components/MultipleReject";
import ExceedMaxRetry from "./components/ExceedMaxRetry";
import EditNameModal from "./components/EditNameModal";
import EditIDNumberModal from "./components/EditIDNumberModal";

const MyTentera = ({ validation, onComplete, onSessionUpdate }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token") || sessionStorage.getItem("ekycSessionToken");

  const {
    uploadFront,
    verifyFront,
    uploadBack,
    verifyBack,
    extractMyTenteraInfo,
  } = useMyTenteraService();

  const [step, setStep] = useState("mytentera-front-guideline");

  const [isSubmitting, setIsSubmitting] = useState(false);

  const [validationID, setValidationID] = useState(null);
  const [hasMyTenteraFrontCheckCompleted, setHasMyTenteraFrontCheckCompleted] =
    useState(false);
  const [hasMyTenteraBackCheckCompleted, setHasMyTenteraBackCheckCompleted] =
    useState(false);

  const [progressStates, setProgressStates] = useState({
    myTenteraFront: "Not Started", // Not Started, Fail, Pass
    myTenteraBack: "Not Started",
    blacklist: "Not Started",
    kenalID: "Not Started",
  });

  const [workflowConfig, setWorkflowConfig] = useState({});
  const [userUploadImageBuffer, setUserUploadImageBuffer] = useState(null);
  const [myTenteraFrontOriginalImageBlob, setMyTenteraFrontOriginalImageBlob] =
    useState(null);
  const [myTenteraFrontImageBlob, setMyTenteraFrontImageBlob] = useState(null);
  const [myTenteraBackOriginalImageBlob, setMyTenteraBackOriginalImageBlob] =
    useState(null);
  const [myTenteraBackImageBlob, setMyTenteraBackImageBlob] = useState(null);
  const [myTenteraHologramImageBlob, setMyTenteraHologramImageBlob] = useState(null);
  const [myTenteraHologramOriginalImageBlob, setMyTenteraHologramOriginalImageBlob] =
    useState(null);
  const [autofillFromOCR, setAutofillFromOCR] = useState(false);
  const [ocrName, setOcrName] = useState("");
  const [ocrIDNumber, setOcrIDNumber] = useState("");
  const [ocrArmyNumber, setOcrArmyNumber] = useState("");
  const [editNameModal, setEditNameModal] = useState(false);
  const [editIDNumberModal, setEditIDNumberModal] = useState(false);

  const [takePhotoErrorMessage, setTakePhotoErrorMessage] = useState("");

  useEffect(() => {
    if (validation) {
      const myTenteraResults =
        validation?.ComponentResults?.[validation.CurrentStep.ID] || {};
      const blacklistResult =
        validation?.ComponentResults?.[
          validation.CurrentStep.ID + "_Blacklist"
        ] || {};
      // const kenalIDResult =
      //   validation?.ComponentResults?.[
      //     validation.CurrentStep.ID + "_KenalID"
      //   ] || {};

      setProgressStates({
        myTenteraFront: myTenteraResults?.MyTenteraFrontResult
          ? myTenteraResults.MyTenteraFrontResult
          : "Not Started",
        myTenteraBack: myTenteraResults?.MyTenteraBackResult
          ? myTenteraResults.MyTenteraBackResult
          : "Not Started",
        blacklist: blacklistResult?.Result
          ? blacklistResult.Result
          : "Not Started",
        // kenalID: kenalIDResult?.Result ? kenalIDResult.Result : "Not Started",
      });

      const config = validation?.WorkflowConfigSnapshot?.Config?.[
        validation.CurrentStep.ID
      ].MyTenteraWorkflowConfig.IDVerification.reduce((acc, item) => {
        acc[item.name] = item["enabled"];
        return acc;
      }, {});
      setWorkflowConfig(config);
      setAutofillFromOCR(config["Autofill From OCR"]);
      setValidationID(validation?.ValidationID);
    }
  }, [validation]);

  useEffect(() => {
    // let totalFail = 0;

    // if (progressStates.myTenteraFront === "Fail") {
    //   totalFail++;
    // }
    // if (progressStates.myTenteraBack === "Fail") {
    //   totalFail++;
    // }
    // if (progressStates.blacklist === "Fail") {
    //   totalFail++;
    // }
    // // if (progressStates.kenalID === "Fail") {
    // //   totalFail++;
    // // }

    // if (totalFail > 1) {
    //   return setStep("multiple-reject");
    // }

    // Check if exceeded max retry first - this takes priority over other conditions
    // Allow "Pass" and "In Review" to proceed
    const overallResult = validation?.ComponentResults?.[validation.CurrentStep.ID]?.Result;
    if (
      validation?.ComponentResults?.[validation.CurrentStep.ID]
        ?.VALIDATION_COUNT >= 3 && 
      overallResult !== "Pass" &&
      overallResult !== "In Review"
    ) {
      return setStep("exceed-max-retry");
    }

    // If overall result is "In Review", proceed to next step (treat like Pass for flow purposes)
    if (overallResult === "In Review") {
      if (onComplete) {
        onComplete({
          validationID: validation?.ValidationID,
        });
      }
      return;
    }

    if (
      progressStates.myTenteraFront === "Pending" ||
      progressStates.myTenteraBack === "Pending"
    ) {
      setStep("verifying");
    } else if (progressStates.myTenteraFront === "Not Started") {
      setStep("mytentera-front-guideline");
    } else if (progressStates.myTenteraFront === "Fail") {
      setStep("mytentera-front-rejected");
    } else if (progressStates.myTenteraBack === "Not Started") {
      setStep("mytentera-back-guideline");
    } else if (progressStates.myTenteraBack === "Fail") {
      setStep("mytentera-back-rejected");
    } else if (progressStates.blacklist === "Fail") {
      setStep("blacklist-rejected");
    }
    //  else if (progressStates.kenalID === "Fail") {
    //   setStep("kenal-id-rejected");
    // }
     else {
      if (onComplete) {
        onComplete({
          validationID: validationID,
        });
      }
    }
  }, [progressStates, workflowConfig, validation]);

  const onNext = (currentStep) => {
    // From current step, determine which step to go next, based on workflow config and also progressStates.

    if (currentStep === "myTenteraFront") {
      if (
        progressStates.myTenteraBack === "Fail" ||
        progressStates.myTenteraBack === "Not Started"
      ) {
        setStep("mytentera-back-guideline");
      } else {
        setStep("verifying");
      }
    } else if (currentStep === "myTenteraBack") {
      setStep("verifying");
    }
  };

  const renderSteps = () => {
    switch (step) {
      case "mytentera-front-guideline":
        return (
          <Guideline
            myTenteraSide="front"
            positiveSampleImage={mytenteraFrontGood}
            negativeSampleImage={mytenteraFrontBad}
            onNext={(imageBuffer) => {
              setUserUploadImageBuffer(imageBuffer);
              setStep("mytentera-front-upload");
            }}
          />
        );
      case "mytentera-front-upload":
        return (
          <UploadPhoto
            useOCRForData={autofillFromOCR}
            imageBuffer={userUploadImageBuffer}
            onSuccess={ async ({
              croppedImageBlob,
              originalImageBlob,
            }) => {
              setMyTenteraFrontImageBlob(croppedImageBlob);
              setMyTenteraFrontOriginalImageBlob(originalImageBlob);

              if (autofillFromOCR === true) {
                const formData = new FormData();
                formData.append("file", croppedImageBlob);
                const res = await extractMyTenteraInfo(formData);
                if (res.status === "success") {
                  setOcrName(res.data.name);
                  setOcrIDNumber(res.data.idNumber);
                  setOcrArmyNumber(res.data.armyNumber);
                }
              }
              setStep("mytentera-front-check-quality");
            }}
            onError={(error, showImage = true) => {
              setTakePhotoErrorMessage({ text: error, showImage });
              setStep("mytentera-front-upload-error");
            }}
          />
        );
      case "mytentera-front-upload-error":
        return (
          <TakePhotoError
            errorMessage={takePhotoErrorMessage.text}
            showImage={takePhotoErrorMessage.showImage}
            imageBuffer={userUploadImageBuffer}
            onRetry={() => {
              setTakePhotoErrorMessage("");
              setStep("mytentera-front-guideline");
            }}
          />
        );
      case "mytentera-front-check-quality":
        return (
          <CheckQuality
            useOCRForData={autofillFromOCR}
            ocrName={ocrName}
            ocrIDNumber={ocrIDNumber}
            ocrArmyNumber={ocrArmyNumber}
            isSubmitting={isSubmitting}
            myTenteraSide="front"
            imageBlob={myTenteraFrontImageBlob}
            onRetake={(imageBuffer) => {
              setUserUploadImageBuffer(imageBuffer);
              setStep("mytentera-front-upload");
            }}
            onConfirm={() => {
              setIsSubmitting(true);
              setHasMyTenteraFrontCheckCompleted(false);

              const formData = new FormData();
              formData.append("validationID", validationID);
              formData.append("autofillFromOCR", autofillFromOCR);
              formData.append("originalImage", myTenteraFrontOriginalImageBlob);
              formData.append("croppedImage", myTenteraFrontImageBlob);

              if (autofillFromOCR === true) {
                formData.append("ocrName", ocrName);
                formData.append("ocrIDNumber", ocrIDNumber);
                formData.append("ocrArmyNumber", ocrArmyNumber);
                }

              uploadFront(formData)
                .then((res) => {
                  onSessionUpdate?.(res.session);
                  if (res.status === "success") {
                    // Submitting for verification, and proceed to mytentera back immediately
                    verifyFront({
                      validationID,
                    }).then((verifyRes) => {
                      onSessionUpdate?.(verifyRes.session);
                      setHasMyTenteraFrontCheckCompleted(true);
                    });
                    onNext("myTenteraFront");
                  }
                  setIsSubmitting(false);
                })
                .catch(() => {
                  setIsSubmitting(false);
                });
            }}
            onEditName={() => {
              setEditNameModal(true);
            }}
            onEditIDNumber={() => {
              setEditIDNumberModal(true);
            }}
          />
        );
      case "mytentera-front-rejected":
        return (
          <MyTenteraReject
            validationID={validationID}
            myTenteraSide="front"
            onRetry={() => setStep("mytentera-front-guideline")}
          />
        );
      case "mytentera-back-guideline":
        return (
          <Guideline
            myTenteraSide="back"
            positiveSampleImage={mytenteraBackGood}
            negativeSampleImage={mytenteraBackBad}
            onNext={(imageBuffer) => {
              setUserUploadImageBuffer(imageBuffer);
              setStep("mytentera-back-upload");
            }}
          />
        );
      case "mytentera-back-upload":
        return (
          <UploadPhoto
            imageBuffer={userUploadImageBuffer}
            onSuccess={({ croppedImageBlob, originalImageBlob }) => {
              setMyTenteraBackImageBlob(croppedImageBlob);
              setMyTenteraBackOriginalImageBlob(originalImageBlob);
              setStep("mytentera-back-check-quality");
            }}
            onError={(error, showImage = true) => {
              setTakePhotoErrorMessage({ text: error, showImage });
              setStep("mytentera-back-upload-error");
            }}
          />
        );
      case "mytentera-back-upload-error":
        return (
          <TakePhotoError
            errorMessage={takePhotoErrorMessage.text}
            showImage={takePhotoErrorMessage.showImage}
            imageBuffer={userUploadImageBuffer}
            onRetry={() => {
              setTakePhotoErrorMessage("");
              setStep("mytentera-back-guideline");
            }}
          />
        );
      case "mytentera-back-check-quality":
        return (
          <CheckQuality
            isSubmitting={isSubmitting}
            myTenteraSide="back"
            imageBlob={myTenteraBackImageBlob}
            onRetake={(imageBuffer) => {
              setUserUploadImageBuffer(imageBuffer);
              setStep("mytentera-back-upload");
            }}
            onConfirm={() => {
              setIsSubmitting(true);
              setHasMyTenteraBackCheckCompleted(false);

              const formData = new FormData();
              formData.append("validationID", validationID);
              formData.append("originalImage", myTenteraBackOriginalImageBlob);
              formData.append("croppedImage", myTenteraBackImageBlob);

              uploadBack(formData)
                .then((res) => {
                  onSessionUpdate?.(res.session);
                  if (res.status === "success") {
                    // Submitting for verification, and proceed to verifiying screen immediately
                    verifyBack({
                      validationID,
                    }).then((verifyRes) => {
                      onSessionUpdate?.(verifyRes.session);
                      setHasMyTenteraBackCheckCompleted(true);
                    });

                    onNext("myTenteraBack");
                  }
                  setIsSubmitting(false);
                })
                .catch(() => {
                  setIsSubmitting(false);
                });
            }}
          />
        );
      case "mytentera-back-rejected":
        return (
          <MyTenteraReject
            validationID={validationID}
            myTenteraSide="back"
            onRetry={() => setStep("mytentera-back-guideline")}
          />
        );
      case "blacklist-rejected":
        return (
          <MyTenteraReject
            validationID={validationID}
            myTenteraSide="blacklist"
            onRetry={() => setStep("mytentera-front-guideline")}
          />
        );
      // case "kenal-id-rejected":
      //   return (
      //     <MyTenteraReject
      //       validationID={validationID}
      //       myTenteraSide="kenalID"
      //       onRetry={() => setStep("mytentera-front-guideline")}
      //     />
      //   );
      case "verifying":
        return (
          <Verifying
            validationID={validationID}
            progressStates={progressStates}
            hasMyTenteraFrontCheckCompleted={hasMyTenteraFrontCheckCompleted}
            hasMyTenteraBackCheckCompleted={hasMyTenteraBackCheckCompleted}
            onSessionUpdate={onSessionUpdate}
            onPass={(checkResult) => {
              // If "In Review", proceed directly to next workflow step
              if (checkResult.overallStatus === "In Review") {
                onComplete({ validationID: validation?.ValidationID });
                return;
              }
              setProgressStates((prev) => ({
                ...prev,
                myTenteraFront: checkResult.front.status,
                myTenteraBack: checkResult.back.status,
              }));
              onNext("verifying");
            }}
            onFail={(checkResult) => {
              if (checkResult.validationCount >= 3) {
                return setStep("exceed-max-retry");
              }

              setTimeout(() => {
                setProgressStates((prev) => ({
                  ...prev,
                  myTenteraFront: checkResult.front.status,
                  myTenteraBack: checkResult.back.status,
                  blacklist: checkResult.blacklist
                    ? checkResult.blacklist
                    : prev.blacklist,
                  // kenalID: checkResult.kenalID
                  //   ? checkResult.kenalID
                  //   : prev.kenalID,
                }));
              }, 2000);
            }}
          />
        );
      case "multiple-reject":
        return (
          <MultipleReject
            progressStates={progressStates}
            onRetry={() => {
              if (progressStates.myTenteraFront === "Fail") {
                setStep("mytentera-front-guideline");
              } else if (progressStates.myTenteraBack === "Fail") {
                setStep("mytentera-back-guideline");
              } else if (progressStates.blacklist === "Fail") {
                setStep("mytentera-front-guideline");
              } 
              // else if (progressStates.kenalID === "Fail") {
              //   setStep("mytentera-front-guideline");
              // }
            }}
          />
        );
      case "exceed-max-retry":
        return <ExceedMaxRetry />;
      case "invalid-token":
        return <InvalidToken />;
      default:
        // Return loading screen
        return <div>Loading...</div>;
    }
  };

  return (
    <div className="min-h-screen w-full bg-gray-50 flex justify-center items-center">
      <div className="min-h-screen w-full max-w-md bg-transparent relative md:rounded-xl md:shadow-lg">
        {!token ? <InvalidToken /> : renderSteps()}

        <EditNameModal
          isOpen={editNameModal}
          initialName={ocrName}
          onClose={() => setEditNameModal(false)}
          onSave={(newName) => {
            setOcrName(newName);
            setEditNameModal(false);
          }}
        />

        <EditIDNumberModal
          isOpen={editIDNumberModal}
          initialIDNumber={ocrIDNumber}
          onClose={() => setEditIDNumberModal(false)}
          onSave={(newIDNumber) => {
            setOcrIDNumber(newIDNumber);
            setEditIDNumberModal(false);
          }}
        />
      </div>
    </div>
  );
};

export default MyTentera;
